const isRegexCode = `import { isRegex } from 'cristatus';

const isRegex = isRegex(/hello/); //true
`;

export default isRegexCode;
